<template>
  <div class="wn-overlay" v-if="show" @click.self="close">
    <div class="wn-box">
      <div class="wn-head">
        <span class="wn-title">Что нового</span>
        <span class="wn-date">{{ releaseDate }}</span>
      </div>

      <div class="wn-body">
        <div class="wn-item" v-for="(item, i) in items" :key="i">
          <span class="wn-num">{{ i + 1 }}.</span>
          <div>
            <p class="wn-item-title">{{ item.title }}</p>
            <p class="wn-item-text">{{ item.text }}</p>
          </div>
        </div>
      </div>

      <div class="wn-foot">
        <button type="button" class="wn-btn" @click="close">Понятно</button>
      </div>
    </div>
  </div>
</template>

<script>
// Номер версии записки. Поменять при следующих изменениях — тогда окно
// покажется снова, в том числе тем, кто уже закрывал предыдущее.
const VERSION = "2026-07-27";
const STORAGE_KEY = "whatsNewSeen";

export default {
  name: "whatsNew",
  data: () => ({
    show: false,
    releaseDate: "27 июля",
    items: [
      {
        title: "Выбор сезона",
        text: "Меню рядом с кнопкой GO — при вставки ссылки на матч можно выбрать нужный сезон или турнир. Работает и с матчем, открытым из сохраненных."
      },
      {
        title: "Ушедшие игроки отмечаются сами",
        text: "Кого уже нет в составе — зачеркнуты и с самолетом. Вручную отмечать не нужно."
      },
      {
        title: "Фильтр прячет и ушедших",
        text: "Кнопка скрытия пустых игроков теперь убирает и тех, кто покинул команду."
      },
      {
        title: "Сезон виден в сохраненных",
        text: "Подпись после названий команд. Один матч за разные сезоны храниться двумя записями."
      }
    ]
  }),
  methods: {
    token() {
      return this.$cookie ? this.$cookie.get("token") : "";
    },

    close() {
      this.show = false;
      try {
        localStorage.setItem(STORAGE_KEY, VERSION);
      } catch (e) {
        // Приватный режим или переполненное хранилище — выручит отметка на сервере
      }
      // Дублируем на сервер: localStorage чистится вместе с данными сайта (а в Chrome
      // это бывает по настройке «очищать при закрытии»), и окно вылезало каждый заход
      const token = this.token();
      if (!token) return;
      this.$axios
        .post("/localstorage", { key: STORAGE_KEY, value: VERSION },
              { headers: { Authorization: token } })
        .catch(() => {});
    }
  },
  async mounted() {
    let seenLocally = false;
    try {
      seenLocally = localStorage.getItem(STORAGE_KEY) === VERSION;
    } catch (e) {
      seenLocally = false;
    }
    if (seenLocally) return;

    // В localStorage отметки нет — спрашиваем сервер, вдруг окно уже закрывали
    const token = this.token();
    if (!token) {
      this.show = true;
      return;
    }
    try {
      const { data } = await this.$axios.get(`/localstorage/${STORAGE_KEY}`,
                                             { headers: { Authorization: token } });
      if (String(data) === VERSION) {
        try { localStorage.setItem(STORAGE_KEY, VERSION); } catch (e) { /* не судьба */ }
        return;
      }
    } catch (e) {
      // Сервер не ответил — покажем окно, это не страшно
    }
    this.show = true;
  }
};
</script>

<style scoped>
.wn-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  padding: 20px;
}
.wn-box {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  text-align: left;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}
.wn-head {
  background: #eaf3de;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wn-title {
  font-size: 21px;
  font-weight: 500;
  color: #173404;
}
.wn-date {
  font-size: 16px;
  color: #3b6d11;
}
.wn-body {
  padding: 4px 20px 8px;
}
.wn-item {
  display: flex;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}
.wn-item:last-child {
  border-bottom: none;
}
.wn-num {
  font-size: 18px;
  font-weight: 500;
  color: #6c757d;
  min-width: 24px;
}
.wn-item-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #2c3e50;
}
.wn-item-text {
  margin: 3px 0 0;
  font-size: 17px;
  color: #6c757d;
  line-height: 1.5;
}
.wn-foot {
  padding: 12px 20px 16px;
  display: flex;
  justify-content: flex-end;
}
.wn-btn {
  background: #639922;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 18px;
  cursor: pointer;
}
.wn-btn:hover {
  background: #567f1f;
}
</style>
